import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { getOrCreatePortalRoot } from '../../utils/portalRoot';
var OFFSET_POSITION = -1000;
export var MobileHeaderModal = function MobileHeaderModal(props) {
  var show = props.show,
    showClose = props.showClose,
    modalClassName = props.modalClassName,
    className = props.className,
    onClose = props.onClose,
    children = props.children;
  var wrapperClasses = classNames('MobileHeaderModal', 'position-fixed left-0 right-0 bottom-0', 'z-index-max', className);
  var modalClasses = classNames('display-flex flex-column justify-content-center', 'margin-15', 'text-center', 'rounded', 'bg-white', 'shadow-hard', 'overflow-auto', modalClassName);
  var modalRoot = getOrCreatePortalRoot();
  var pageHeight = window.innerHeight - 30;
  var offset = OFFSET_POSITION - window.innerHeight;
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnimatePresence, null, show && /*#__PURE__*/React.createElement(motion.div, {
    className: wrapperClasses,
    initial: {
      opacity: 0,
      top: offset
    },
    animate: {
      opacity: 1,
      y: 0,
      top: 0
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.3
      },
      top: offset
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: modalClasses,
    style: {
      height: "".concat(pageHeight, "px")
    }
  }, children), showClose && /*#__PURE__*/React.createElement("div", {
    className: 'position-absolute top-15 right-15 margin-top-15 margin-right-15 ' + 'text-size-20 text-color-dark',
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-remove"
  })))), /*#__PURE__*/React.createElement(AnimatePresence, null, show && /*#__PURE__*/React.createElement(motion.div, {
    className: "bottom-sheet-backdrop",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.5
    },
    exit: {
      opacity: 0
    }
  }))), modalRoot);
};
MobileHeaderModal.defaultProps = {
  show: false,
  showClose: true,
  onClose: function onClose() {}
};
MobileHeaderModal.propTypes = {
  show: PropTypes.bool,
  showClose: PropTypes.bool,
  modalClassName: PropTypes.string,
  onClose: PropTypes.func,
  className: PropTypes.string
};